import { Link, useParams, useSearchParams } from "react-router-dom";
import { useAppSelector } from "../../../app/store";
import Avatar from "../../../assets/images/avatar.svg";
import { ChatItem } from "../../../types/chat";

export default function ConversationItem({
  conversation,
}: {
  conversation: ChatItem;
}) {
  const auth = useAppSelector((state) => state.auth);
  const { id } = useParams();
  const [searchParams] = useSearchParams();
  const chatId = searchParams.get("chatId");

  let basePath = "/user/communication/message";

  if (auth?.role === "super_admin" || auth?.role === "Admin") {
    basePath = "/admin/communication/message";
  }

  let url = "";

  if (conversation?.type === "one_to_one") {
    url = `${basePath}/${conversation?.connectedUser?.id}?chatId=${conversation?.chatId}`;
  } else {
    url = `${basePath}/group?chatId=${conversation?.chatId}`;
  }

  return (
    <Link to={url}>
      <div
        className={`chat-item p-2 gap-3 flex items-center cursor-pointer  ${
          conversation?.connectedUser?.id === Number(id) ||
          (id === "group" && conversation?.chatId === Number(chatId))
            ? "bg-light/30"
            : ""
        }`}
      >
        <div className="w-10 h-10 rounded-full overflow-hidden">
          <img
            className="w-full h-full object-cover"
            src={conversation?.connectedUser.pro_pic || Avatar}
            alt="Avatar"
          />
        </div>
        <div className="flex-1">
          <div className="flex justify-between items-center gap-1">
            <div className="font-medium flex-1 text-base truncate overflow-hidden whitespace-nowrap max-w-[140px] !hover:text-[#69b1ff]">
              {conversation?.connectedUser?.name}
            </div>
            <div className="text-slate-600 text-xs font-medium w-[80px] text-end">
              {conversation?.lastMessage?.createdAt &&
                new Date(
                  conversation.lastMessage?.createdAt,
                ).toLocaleDateString("en-US", {
                  year: "numeric",
                  month: "short",
                  day: "numeric",
                })}
            </div>
          </div>
          <div className="flex justify-between gap-4">
            <div className="text-[#455468] truncate overflow-hidden whitespace-nowrap w-[150px]">
              <span>{conversation?.lastMessage?.content}</span>
            </div>
            {conversation?.unseenCount > 0 && (
              <div className="w-5">
                <span className="w-4 h-4 flex justify-center items-center bg-[#E9EFF6] text-[10px] rounded-full p-3">
                  {conversation?.unseenCount}
                </span>
              </div>
            )}
          </div>
        </div>
      </div>
    </Link>
  );
}
